import zh_CN from './zh_CN/MENUSLIDE.json'
import enUS from 'vant/es/locale/lang/en-US'
import { Locale } from 'vant'
export default {
  name: 'MENUSLIDE',
  version: 4,
  zh_CN,
  project: 'pc-gateway',
  effect: (lang) => {
    if (lang === 'en_US') {
      Locale.use('en-US', enUS)
    }
  }
}